export default "__VITE_ASSET__Czmu8Nq0__"